// Cookie Banner Fix - Force immediate close
(function() {
  function init() {
    const acceptBtn = document.getElementById('shopify-pc__banner__btn-accept');
    const declineBtn = document.getElementById('shopify-pc__banner__btn-decline');
    const banner = document.getElementById('shopify-pc__banner');

    if (!banner) return;

    function hideBanner() {
      banner.style.opacity = '0';
      banner.style.transform = 'translateY(20px)';
      banner.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      setTimeout(function() {
        banner.style.display = 'none';
      }, 300);
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function() {
        hideBanner();
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', function() {
        hideBanner();
      });
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after delay in case banner loads async
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();